import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { PaymentTermParams } from '../../../Models/ops';

@Component({
  selector: 'app-ops-payment-terms',
  templateUrl: './ops-payment-terms.component.html',
  styleUrls: ['./ops-payment-terms.component.css']
})
export class OpsPaymentTermsComponent implements OnInit {;
  public PaymentTermParams:PaymentTermParams;
  private utility: Utility;
  constructor(
    private cookieService: CookieService,
    private _NotificationService: NotificationService
  ) {        
    this.PaymentTermParams=  new PaymentTermParams();
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {
    // alert(2);
    // this.IsForSpra = false;
  }




  Validation(): boolean {
    if (this.PaymentTermParams.Term == 'Credit' && !this.utility.CheckNumberRequired(this.PaymentTermParams.CreditDays)) {
      this._NotificationService.showError("Please enter credit days.", "Payment Term");
      return false
    }
    return true;

  }

}
